// Check that the input number is positive
const numericValidation = value => {
	const parsedNum = Number.parseInt(value, 10);
	if (value && parsedNum < 0) {
		return `Please enter a positive number`;
	}
	return undefined;
};

export default numericValidation;
